import { render, staticRenderFns } from "./SiteLocked.vue?vue&type=template&id=671c725a&"
import script from "./SiteLocked.vue?vue&type=script&lang=ts&"
export * from "./SiteLocked.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SiteLocked.vue"
export default component.exports